<template>
  <div class="hkld-header">
    <a
      id="logo"
      :disabled="!showLoggedInContent"
      @click="toHome"
    >
      <img
        v-if="showLoggedInContent"
        v-region-img-src="'hkld-logo.png'"
        class="hkld-logo"
        alt="Hongkong Land"
      >
      <img
        v-if="!showLoggedInContent"
        class="hkld-logo"
        src="/hkld-logo.png"
        alt="Hongkong Land"
      >
    </a>
    <NavBar />
    <SwitchLanguages />
    <SwitchRegions v-if="showLoggedInContent" />
    <ul
      v-show="showLoggedInContent"
      id="dropdown-menu"
      class="dropdown menu hamburger-box"
      data-dropdown-menu
      data-disable-hover="true"
      data-click-open="true"
    >
      <li class="dropdown-submenu-parent">
        <svg
          id="hamburger"
          width="66"
          height="66"
          style="cursor:pointer;"
        >
          <line
            x1="22"
            x2="44"
            y1="24"
            y2="24"
            stroke="white"
            stroke-width="2"
          />
          <line
            x1="22"
            x2="44"
            y1="32"
            y2="32"
            stroke="white"
            stroke-width="2"
          />
          <line
            x1="22"
            x2="44"
            y1="40"
            y2="40"
            stroke="white"
            stroke-width="2"
          />
        </svg>
        <ul class="menu menu-content">
          <li class="list-item">
            <span class="user-hello">
              {{ renderedHi }}
              <br>
              <a
                id="user_name"
                class="user-name"
                @click="goToProfile()"
              >
                {{ renderedName }}
              </a>
            </span>
          </li>
          <template v-for="(item, index) in items">
            <li
              :key="index"
              class="list-item"
              style="cursor:pointer;"
              @click="goTo(item.target, item.params)"
            >
              <a
                :id="'hamburger'+index"
                class="hamburger-item"
              >
                {{ item.title }}
              </a>
            </li>
          </template>
          <li class="list-item">
            <a
              id="logout"
              class="hamburger-item"
              @click="logout()"
            >
              {{ $t("logout") }}
            </a>
          </li>
        </ul>
      </li>
    </ul>

    <confirm-continue
      ref="hamburgerComfirm"
      style="display:block"
    />
    <project-control-leave-modal />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import lodash from 'lodash'
import { getUserTenantPerms } from '@/api/users/request'
import ConfirmContinue from '@/modules/ConfirmContinue'
import ProjectControlLeaveModal from '@/modules/tenantProjects/projectControl/ProjectControlLeaveModal'
import EventBus from '@/utils/eventBus'
import hamburgerMenu from '@/utils/hamburgerMenu'
import navigation from '@/utils/navigation'
import SwitchLanguages from './SwitchLanguages'
import SwitchRegions from './SwitchRegions'
import NavBar from './NavBar'
import { useActivePage } from './hook'
import useLoginStatus from '../useLoginStatus'
import { ENGINEER_DASHBOARD_ROUTE } from '@/utils/locale'

export default {
  components: {
    ConfirmContinue,
    ProjectControlLeaveModal,
    SwitchLanguages,
    SwitchRegions,
    NavBar,
  },
  setup () {
    const { showLoggedInContent } = useLoginStatus()
    const activePage = useActivePage()
    return { showLoggedInContent, activePage }
  },
  data () {
    return {
      hasTenancyRecords: false,
    }
  },
  computed: {
    ...mapGetters('user', ['isEngineer', 'currentUser', 'currentUserContact', 'isTenant', 'isContractor']),
    renderedName () {
      let result
      if (this.isTenant || this.isContractor) {
        result = this.$i18n.t('user.profile.title')
      } else {
        result = lodash.get(this.currentUserContact, 'contactAdmin') || this.currentUser.name || this.$i18n.t('hklandUser')
      }
      return result
    },
    items () {
      const menuMap = {
        isEngineer: 'engineerMenu',
        isTenant: 'tenantMenu',
        isContractor: 'contractorMenu',
      }
      const menuFnName = menuMap[Object.keys(menuMap).find(key => this[key])]
      const options = menuFnName === 'tenantMenu'
        ? { hasTenancyRecords: this.hasTenancyRecords }
        : undefined
      const result = menuFnName ? hamburgerMenu[menuFnName](options) : []
      return result
    },
    renderedHi () {
      let result
      if (this.isTenant || this.isContractor) {
        result = ''
      } else {
        result = this.$i18n.t('hello')
      }
      return result
    },
  },
  watch: {
    items () {
      this.refreshMenu()
    },
    'currentUser.id': {
      immediate: true,
      handler (userId) {
        this.hasTenancyRecords = false
        if (!this.isTenant || !userId) return

        getUserTenantPerms(userId)
          .then(user => {
            if (this.currentUser.id === userId) {
              this.hasTenancyRecords = (user.tenancyAccount || []).length > 0
            }
          })
          .catch(() => {
            if (this.currentUser.id === userId) this.hasTenancyRecords = false
          })
      },
    },
  },
  mounted () {
    this.initMenu()
    if (this.isTenant) {
      this.activePage = 'tenantDashboard'
    }

    EventBus.on('module_vue_router_finished_loading', (toPageName) => {
      this.activePage = lodash.get(toPageName, 'name', '/')
    })
    EventBus.on('module_header_menu_open', () => {
      document.querySelector('#dropdown-menu > li.dropdown-submenu-parent > .menu-content').click()
    })
  },
  destroyed () {
    if (this.dropdown) {
      this.dropdown.destroy()
    }
    EventBus.off('module_vue_router_finished_loading')
    EventBus.off('module_header_menu_open')
  },
  methods: {
    ...mapActions('user', ['logout']),
    toHome () {
      if (this.isTenant) {
        this.activePage = 'tenantDashboard'
      } else {
        this.activePage = ENGINEER_DASHBOARD_ROUTE.TMS
      }
      navigation.toHome()
    },
    goToProfile () {
      if (this.isContractor) {
        navigation.toPage('vendorProfile')
      } else if (this.isTenant) {
        navigation.toPage('tenantProfile')
      } else {
        navigation.toPage('profile')
      }
    },
    goTo (target, params) {
      if (this.$router.currentRoute.name === target) {
        return
      }
      navigation.toPage(target, params)
    },
    initMenu () {
      if (this.dropdown && Object.keys(this.dropdown).length > 0) {
        if ($('#dropdown-menu').childElementCount > 0) {
          this.dropdown.destroy()
        }
        delete this.dropdown
      }
      if (!this.dropdown) {
        this.dropdown = new Foundation.DropdownMenu($('#dropdown-menu'))
      }
    },
    refreshMenu () {
      setTimeout(this.initMenu, 0)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~styles/settings';

.menu>li>a {
  padding: 0;
}

.hkld-header {
  width: 100%;
  background-color: #05273f;
  height: $header-height;
  display: flex;
}
#logo {
    line-height: inherit;
    color: #1779ba;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    flex-basis: 264px;
    flex-grow: 0;
    flex-shrink: 0;
}
.hkld-logo {
  padding: 13px 24px;
}

.hamburger-box {
  flex: 66px 0 0;
  height: 66px;
  background-color: #1a557d;
  align-self: center;
  justify-self: right;
}

.menu-content {
  background-color: $tender-font-color;
  top: 66px!important;
  right: 0;
  width: 289px;
  min-height: calc(100vh - 66px);
  padding: 0 26px 0 20px;
  border: 0;
  margin: 0;
  z-index: 1000;
}

.list-item {
  box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.26);
  border-bottom: solid 1px rgba(0, 0, 0, 0.32);
  padding: 22px 0 22px 0;
}

.hamburger-item {
  font-size: 16px;
  color: white;
}

.user-hello {
  font-size: 24px;
  color: white;
  font-family: Georgia;
  font-size: 24px;
}

.user-name {
  display: block;
  position: relative;
  font-size: 24px;
  color: #6282bd;
  font-style: italic;
  word-break: break-word;
  text-transform: capitalize;
  cursor: pointer;
  &:after {
    position: absolute;
    right: 0;
    bottom: 10px;
    content: "\F107";
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    font-size: 25px;
    color: white;
    transform: rotate(265deg);
  }
}

#dropdown-menu .is-dropdown-submenu-parent{
  font-size: 0;
}
</style>
